import type { Referrer } from '../../types';
import { contexts } from '../contexts';
import { referrersToContextIds } from '../referrersToContextIds';
import type { ContextByReferrer } from '../types';

export const getContextByReferrer = <T extends Referrer>(
  referrer: T,
): ContextByReferrer<T> | undefined => {
  const result = contexts.find((context) => context.id === referrersToContextIds[referrer]);

  return result as ContextByReferrer<T>;
};
